<template>

  <v-navigation-drawer 
    v-if="$store.state.auth.user.role == 1 || $store.state.auth.user.role == 2 || $store.state.auth.user.role == 4 && $store.state.auth.loggedIn" 
    v-model="$store.state.auth.loggedIn" 
    width="250"
    app fixed stateless clipped touchless permanent>
    <v-toolbar flat class="transparent header">

      <img src="../assets/coi-logo.png"/>

    </v-toolbar>
    <v-list dense>
      <div v-for="(item, index) in items" :key="index">
        <template v-if="item.subItems !=undefined">
            <v-list-group :prepend-icon="item.icon" :value ="false"  no-action>
              <v-list-tile slot="activator" >
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <div v-for="(subitem, jindex) in item.subItems" :key="jindex" >
                <template v-if="subitem.subsubItems !=undefined">
                  <v-list-group sub-group  :value ="false"  no-action >
                    <v-list-tile   :to="subitem.to" slot="activator">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ subitem.title }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile  v-for="(subsubitem, tindex) in subitem.subsubItems" :key="tindex" :to="subsubitem.to">
                      <v-list-tile-content> 
                        <v-list-tile-title>{{ subsubitem.title }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list-group>
                </template>
                <template v-else>
                  <v-list-tile :to="subitem.to">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ subitem.title }}</v-list-tile-title>
                      </v-list-tile-content>
                  </v-list-tile>
                </template>
              </div>
            </v-list-group>
        </template> 
        <template v-else>
          <v-list-tile :to="item.to" v-if="item.title=='Logout'" @click="logout()">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="item.to" v-else>
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>  
        </template>
      </div>
    </v-list>

<!--    <Footer />-->
  </v-navigation-drawer>

</template>

<script>
    import AuthenticationService from "@/services/AuthenticationService";
    import Footer from "@/components/Footer";

    export default {
  name: "SideNavigation",
  components: {
    Footer
  },
  data() {
    return {
      show: false,
      items: [
        {
          title: "Dashboard",
          icon: "fas fa-tachometer-alt",
          to: { name: "dashboard" }
        },
        {
            title: "Courses",
            icon: "notes",
            to: { name: "allCourses" }
        },
        {
            title: "Questions",
            icon: "notes",
            to: { name: "allQuestions" }
        },
        {
            title: "Interactions",
            icon: "notes",
            to: { name: "allInteractions" }
        },
        {
            title: "G-Classroom",
            icon: "notes",
            subItems: [
                { title: "Classrooms", icon: "notes", to: { name: "classrooms"}},
                { title: "Course Work", icon: "notes", to: { name: "courseWork"}},
                { title: "Teachers", icon: "notes", to: { name: "teachers" } },
                { title: "Student", icon: "notes", to: { name: "students" } },
                { title: "Grades", icon: "notes", to: { name: "grades" } },
                { title: "Topics", icon: "notes", to: { name: "topics" } },
            ]
        },
        {
          title: "Wordpress",
          icon: "notes",
          subItems: [
              {title: "Uploads", icon: "notes", to: { name: "wordpress-upload"}},
          ]
        },
        {
            title: "Reports",
            icon: "notes",
            subItems: [
                { title: "Digital Literacy", to: { name: "digitalLit" } },
                { title: "Progress", to: {name: "performance"}}
            ],
        },
        {
          title: "Settings",
          icon: "settings",
          subItems: [
            // { title: "Change Password", to: { name: "changePassword" } },
            // { title: "Configure Fields", to: { name: "configureFields" } },
            // { title: "Admins", to: { name: "allAdmins" } },
            { title: "Users", to: { name: "allUsers" } },
            { title: "Students", to: { name: "allStudents" } },
          ]
        },
        { title: "Logout", icon: "exit_to_app" }
      ],
       admins: [
        ['Management', 'people_outline'],
        ['Settings', 'settings']
      ],
      cruds: [
        ['Create', 'add'],
        ['Read', 'insert_drive_file'],
        ['Update', 'update'],
        ['Delete', 'delete']
      ]
    };
  },
  methods: {
    async logout() {
      try {
        // eslint-disable-next-line
        const response = await AuthenticationService.logout({
          userId: this.$store.state.auth.user.email
        });
        // console.log(response.data)
        this.$store.dispatch("logout");
        this.$session.destroy();
        this.$router.push({ name: "signIn" });
        this.$store.dispatch("setSnackbar", { show: true, text: "Logged out", color: "info", x: "right", timeout: 3000 });
      } catch (err) {
        console.log(err.response.data.error);
        this.$store.dispatch("setSnackbar", { show: true, text: "Error Occured", color: "error", x: "right", timeout: 3000 });
      }
    }
  }
};
</script>

<style scoped>

.fas {
  font-size: 20px !important;
  text-align: center;
}

img {
  position: absolute;
  height: 80px;
  width: 75%;
  padding: 15px;
  float: left;
  left: 0px;
  top: 0px;
  /* background: red; */
}

.header {
  position: relative;
  height: 80px;/* background: grey !important; */
}

.list__tile--active .icon {
  color:red !important;
}
</style>
